function VipGuestList() {
    return (
      <>
        <div className="font-bold text-lg mb-16">VipGuestList</div>
      </>
    );
  }
  
  export default VipGuestList;